import './ErrorForm.scss';
import { Form } from '@components/Component/Container/Form/Form.js';
import { DataRecord } from '@components/DataRecord/DataRecord.js';
import { getID } from '@components/Utility/index.js';
import { DynamicText } from '@components/Component/TextBase/DynamicText/DynamicText.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * `ErrorForm` class that extends `Form`.
 * This class represents a login page with input fields for userid and password and a submit button.
 */
export class ErrorForm extends Form {
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'ErrorForm';
        this.loadExternalData = false;
        this.title = 'Fatal Error';
        this.captionKey = 'system_errorform';
    }
    initializeRecords() {
        this.record = new DataRecord(getID('ErrorForm'));
    }
    initializeComponents() {
        const message = new DynamicText('message');
        this.componentsAdd([
            message
        ]);
    }
    template() {
        const errorIcon = DIContainer.getInstance('IconManager').getIconString('error');
        return `
		<div class="error-container">
			${errorIcon}
			<span data-componentid="message" class="error-message"></span>
		</div>`;
    }
}
ErrorForm.VERSION = '$Revision: 118211 $';
